import { ConfigApi, createApiRef, FetchApi } from '@backstage/core-plugin-api';

type Options = {
  configApi: ConfigApi;
  fetchApi: FetchApi;
};

export const fcmApiRef = createApiRef<FcmAPI>({
  id: 'plugin.notifier.service',
});

export class FcmAPI {
  private readonly backendUrl: string | undefined;
  private readonly fetchApi: FetchApi;

  constructor(options: Options) {
    this.backendUrl = options.configApi.getOptionalString('backend.baseUrl');
    this.fetchApi = options.fetchApi;
  }

  async sendNotification(payload: {
    title?: string;
    body?: string;
    recipients: string;
  }) {
    const response = await this.fetchApi.fetch(
      `${this.backendUrl}/api/notifier/fcm/send`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      },
    );

    if (!response.ok) {
      throw new Error(`Failed to send notification: ${response.statusText}`);
    }

    return response.json();
  }

  async subscribeToTopic(token: string, topic: string) {
    if (!token || !topic) {
      throw new Error('Missing token or topic in request body');
    }
    const response = await this.fetchApi.fetch(
      `${this.backendUrl}/api/notifier/fcm/subscribe`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ token, topic }),
      },
    );

    if (!response.ok) {
      const errText = await response.text();
      throw new Error(`Failed to subscribe to topic: ${errText}`);
    }

    return response.json();
  }

  async unsubscribeFromTopic(token: string, topic: string) {
    if (!token || !topic) {
      throw new Error('Missing token or topic in request body');
    }
    const response = await this.fetchApi.fetch(
      `${this.backendUrl}/api/notifier/fcm/unsubscribe`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ token, topic }),
      },
    );

    if (!response.ok) {
      const errText = await response.text();
      throw new Error(`Failed to unsubscribe from topic: ${errText}`);
    }

    return response.json();
  }
}
